// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","label":"_2ESlK7pv4zzAy7_McMcRqu","section":"fSYqOVeH5WxT5ylwqPdqn"};